
import { faClock, faXmark } from '@fortawesome/pro-regular-svg-icons'
import { bookingStatus } from 'pawpaddock-common/data/status'

export default {
  name: 'BookingDate',

  props: {
    booking: {
      type: Object,
      required: true
    },

    showIsNoLongerValid: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      faClock,
      faXmark
    }
  },

  computed: {
    compIsNoLongerValid() {
      if (!this.showIsNoLongerValid) {
        return false
      }

      return (
        [bookingStatus.RESCHEDULED, bookingStatus.REFUNDED].includes(this.booking.status) ||
        this.$dateNew.fromSQL(this.booking.startAt) < this.$dateNew.now().startOf('day')
      )
    }
  }
}
